var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('d-text',{staticClass:"primary--text",attrs:{"size":12}},[_vm._v(_vm._s(_vm.roles))])
}
var staticRenderFns = []

export { render, staticRenderFns }